import './TimeSlotList.css';
export default {
    "accordionListWrapper": "TimeSlotList_accordionListWrapper__1gkp4",
    "timeSlotContainer": "TimeSlotList_timeSlotContainer__1gkp4",
    "disabled": "TimeSlotList_disabled__1gkp4",
    "signalTextContainer": "TimeSlotList_signalTextContainer__1gkp4",
    "signalWithOnlyIconWrapper": "TimeSlotList_signalWithOnlyIconWrapper__1gkp4",
    "signalTextWrapper": "TimeSlotList_signalTextWrapper__1gkp4",
    "disabledSessionText": "TimeSlotList_disabledSessionText__1gkp4",
    "sessionText": "TimeSlotList_sessionText__1gkp4"
};
